module.exports = __webpack_public_path__ + "img/mc_symbol.d205fa5d.svg";